import Link from 'next/link';

import { ChevronRight } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import { LinkViewModel } from '@api/index';
import Typography from '@components/Typography';

import {
  ItemArrow,
  ItemImage,
  Wrapper,
  Circle,
  ContentWrapper,
  List,
  Label,
  ListItem,
  ItemContainer,
} from './styled';

export interface Props {
  items: Omit<LinkViewModel, 'external'>[];
  image: string;
  label: string;
  cityNameKey?: string;
  linkKey?: string;
  slug?: string;
}

const PopularCities = ({ items, label, image, slug }: Props) => {
  return (
    <Wrapper>
      <ItemImage src={image} alt={label} fill />

      <ContentWrapper>
        {slug ? (
          <Link href={slug as string} prefetch={false}>
            <Label clickable={true}>{label}</Label>
          </Link>
        ) : (
          <Label>{label}</Label>
        )}

        <List>
          {items?.map((item, index) => (
            <ListItem key={index}>
              <Circle />
              <ItemContainer>
                <Typography color='D100' variant='caption1' weight='Light'>
                  {item.name}
                </Typography>
              </ItemContainer>
              <Link href={item.href as string} prefetch={false}>
                <ItemArrow>
                  <CustomIcon icon={ChevronRight} fontSize={10} />
                </ItemArrow>
              </Link>
            </ListItem>
          ))}
        </List>
      </ContentWrapper>
    </Wrapper>
  );
};

export default PopularCities;
